import React, { useContext } from 'react';
import { GetSocialProfiles_workspace_socialProfiles } from '../../../../models/legacy-graphql';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { BoxNotification } from '../../../../components/containers/BoxNotification';
import { Link } from 'react-router-dom';
import { Modal } from '../../../../components/containers/Modal';
import { RemoveProfileConfirmationType } from '../Profiles.controller';
import { BeaconContext } from '../../../../providers/BeaconProvider';

export type DeleteModalViewProps = {
  //
  loading: boolean;
  closeDeleteProfileModal: VoidFunction;
  removeProfileModal: RemoveProfileConfirmationType;
  deleteProfile: (profileId: string, typename: GetSocialProfiles_workspace_socialProfiles['__typename']) => void;
};

export const DeleteModalView = (props: DeleteModalViewProps): JSX.Element => {
  const { beacon } = useContext(BeaconContext);
  return (
    <Modal
      closeOnClickOutside={!props.loading}
      closeOnEsc={!props.loading}
      onClose={() => props.closeDeleteProfileModal()}
      showCloseIcon={!props.loading}
      title={'Remove Profile?'}
      primaryButtonTitle={'Remove Profile'}
      primaryButtonAction={() =>
        props.deleteProfile(
          props.removeProfileModal.profileId,
          props.removeProfileModal.typename as GetSocialProfiles_workspace_socialProfiles['__typename']
        )
      }
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonDisabled={props.loading}
      primaryButtonLoading={props.loading}>
      <p data-testid={'permanentlyDelete'}>
        Are you sure you want to <strong>permanently delete</strong> this Social Profile?
      </p>
      <div className={'margin-bottom-small-16'}>
        <BoxNotification type={'error'}>
          You will lose ALL posts, timeslots, and analytics for this Profile.
        </BoxNotification>
      </div>
      <p className={'no-b-m'}>
        If you are you having problems with the profile connection, <strong>do not delete the profile</strong>; please{' '}
        <Link
          to={'#'}
          onClick={() => {
            beacon('open');
            beacon('navigate', '/ask');
          }}>
          contact us
        </Link>
        , and we will be able to help you.
      </p>
    </Modal>
  );
};
